












import Vue from 'vue';

import { Button } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    Button,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { internalActive: this.active };
  },
  watch: {
    active(value) {
      this.internalActive = value;
    },
  },
  methods: {
    clickHandler(event: Event) {
      if (this.internalActive) this.$emit('click', event);
    },
  },
});
